export const buildRoute = (storage, sample) => {
	if (!storage) {
		return '/collection';
	} else {
		if (!sample) {
			return `/collection/${storage.id}`;
		}
		return `/collection/${storage.id}/${sample.id}`;
	}
};
